import * as t from "io-ts"

// Define the IUpload type
const Upload = t.intersection([
    t.type({
        name: t.string,
        loading: t.boolean,
    }),
    t.partial({
        fileUrl: t.union([t.string, t.undefined]),
        size: t.number,
        preview: t.string,
    }),
])

// Define the IUploadArray type
const IUploadArray = t.array(Upload)

export type IUpload = t.TypeOf<typeof Upload>

// Rewrite the isIUploadArray function
export const isIUploadArray = (value: unknown): value is IUpload[] =>
    IUploadArray.is(value)

// Files which failed to be uploaded
export interface IRejectedFiles {
    name: string
    reason: string
}

export interface IPostAttchResponse {
    file_url: string
}

// Input to uploadAttachment function
export interface IUploadData {
    base64Img: string
    uploadName: string
}

// Output from uploadAttachment function
export interface IUploadResult {
    fileUrl?: string
    uploadName: string
    status: "fulfilled" | "rejected"
}
